var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadAttachFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6182 7.15627L11.9153 6.35627C11.7211 6.13547 11.3851 6.11413 11.1633 6.3072L9.06728 8.144V0.533333C9.06728 0.238933 8.82835 0 8.53395 0H7.46728C7.17288 0 6.93395 0.238933 6.93395 0.533333V8.144L4.83795 6.3072C4.61715 6.11413 4.28115 6.13547 4.08595 6.35627L3.38301 7.1552C3.18781 7.37707 3.21021 7.7152 3.43208 7.90933L7.64968 11.6011C7.85128 11.7771 8.15101 11.7771 8.35261 11.6011L12.5691 7.90933C12.791 7.7152 12.8134 7.37707 12.6182 7.15627Z",
    fill: "#929292"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8663 13.8672H2.13294C1.83854 13.8672 1.59961 14.1061 1.59961 14.4005V15.4672C1.59961 15.7616 1.83854 16.0005 2.13294 16.0005H13.8663C14.1607 16.0005 14.3996 15.7616 14.3996 15.4672V14.4005C14.3996 14.1061 14.1607 13.8672 13.8663 13.8672Z",
    fill: "#929292"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadAttachFile);
export default __webpack_public_path__ + "static/media/download-attach-file.258b44a6.svg";
export { ForwardRef as ReactComponent };